// const baseUrl = 'http://59.231.9.236:9022' 本地服务器使用
// const baseUrl = 'http://59.225.200.149:10002' 省网服务器使用 
// const baseUrl = 'http://59.213.217.6:10002' 阿坝服务器使用

const baseUrl = IPConfig.IP
export default baseUrl